import { useMsal } from '@azure/msal-react';
import { Button } from '@healthinal/ui';
import { AxiosError, isAxiosError } from 'axios';
import { ReactNode } from 'react';

export interface ErrorPresentation {
  title?: string;
  description: string;
  details?: string;
  actions?: ReactNode;
  shouldBeReported: boolean;
  shouldBeHandledAtRoot?: boolean;
}

export const interpretError = (error: unknown): ErrorPresentation => {
  if (isAxiosError(error)) {
    if (error.code === AxiosError.ERR_NETWORK) {
      return {
        shouldBeReported: false,
        title: 'Netzwerkfehler',
        description:
          'Es ist ein Fehler bei der Verbindung zum Server aufgetreten. Bitte überprüfen Sie Ihre Verbindung zum Internet.',
      };
    }

    if (error.response?.status === 401) {
      return {
        shouldBeReported: false,
        shouldBeHandledAtRoot: true,
        title: 'Login ungültig',
        description: 'Ihr Login ist nicht mehr gültig. Bitte melden Sie sich erneut an.',
        actions: <LogoutButton />,
      };
    }

    if (error.response?.status === 403) {
      return {
        shouldBeReported: false,
        title: 'Zugriff verweigert',
        description: 'Sie haben keine Berechtigung für diese Aktion.',
        actions: <LogoutButton />,
      };
    }
  }

  return {
    shouldBeReported: true,
    title: 'Unbekannter Fehler',
    description: 'Ein unbekannter Fehler ist aufgetreten.',
    details: error?.toString(),
  };
};

function LogoutButton() {
  const { instance: msalInstance } = useMsal();

  return (
    <Button variant="soft" color="neutral" fullWidth onClick={() => msalInstance.logoutRedirect()}>
      Logout
    </Button>
  );
}
